import { BusinessTypeEnum } from 'gql/types'

export const isAccountingFirm = (businessType: BusinessTypeEnum | null) =>
  businessType === BusinessTypeEnum.ACCOUNTING_PARTNER
